<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="话题名称" prop="keywords">
                <el-input v-model="query.keywords" placeholder="请输入话题名称" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('/community/topic/export') || permission('/community/topic/add')">
            <el-button v-if="permission('/community/topic/export')" size="mini" icon="el-icon-download" @click="handleExport">
                导出数据
            </el-button>
            <el-button v-if="permission('/community/topic/add')" size="mini" icon="el-icon-plus" type="primary" @click="handleAdd">
                新增话题
            </el-button>
        </template>
        <template slot="columns">
            <el-table-column type="index" label="序号" width="100" align="center" />
            <el-table-column label="话题名称" align="center" prop="topicName"></el-table-column>
            <el-table-column label="帖子数量" align="center" prop="postCount"></el-table-column>
            <el-table-column label="操作" align="center" width="140" v-if="permission('/community/topic/edit') || permission('/community/topic/delete')">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/community/topic/edit')" :underline="false" type="primary" @click="handleEdit(row)">
                        编辑
                    </el-link>
                    <el-link v-if="permission('/community/topic/delete')" :underline="false" type="danger" @click="handleDelete(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
        <el-dialog :title="mode === 'add' ? '新增话题' : '编辑话题'" :visible.sync="visible" width="30%">
            <el-form :model="form" ref="form" :rules="rules" label-width="120px">
                <el-form-item label="话题名称" prop="topicName">
                    <el-input v-model="form.topicName" placeholder="请输入话题名称" />
                </el-form-item>
                <el-form-item label="话题权重" prop="weight">
                    <el-input v-model="form.weight" placeholder="请输入话题权重" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </div>
        </el-dialog>
    </ListPage>
</template>

<script>
import { page, add, edit, del } from "@/api/community/topic";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                keywords: "",
                pageNo: 1,
                pageSize: 10,
            },
            visible: false,
            mode: 'add',
            form: {
                topicName: '',
                weight: '',
            },
            rules: {
                topicName: [{ required: true, message: '请输入话题名称' }],
                weight: [{ required: true, message: '请输入话题权重' }],
            },
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.mode = 'add';
            this.form = {
                topicName: '',
                weight: '',
            };
            this.visible = true;
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        handleEdit(row) {
            this.mode = 'edit';
            this.visible = true;
            this.form = { ...row };
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                if (this.mode === 'edit') {
                    edit(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.visible = false;
                            this.search();
                        } else {
                            this.$message.error(message);
                        }
                    });
                } else {
                    add(this.form).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success('保存成功');
                            this.visible = false;
                            this.search();
                        } else {
                            this.$message.error(message);
                        }
                    });
                }
            });
        },
        handleExport() { },
        handleDelete(row) {
            this.$confirm("确定删除该话题吗？", "提示", { type: "warning" }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功');
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                });
            }).catch(() => { });
        }
    },
};
</script>